import * as React from "react";
import { useContext } from "react";
import { ArchiveButtonTypeEnum } from "./ArchiveButtonTypeEnum";
import { AuthContext } from "src/components/context/AuthContext";
import { ServiceContext } from "src/services/provider/Service.provider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive } from "@fortawesome/free-solid-svg-icons";
import IArchiveButton from '../IArchiveButton';
import IGenericButtons from 'src/components/common/GenericButtons/Interfaces/IGenericButtons';
import { ShowNotification } from 'src/components/common/ShowNotification/ShowNotification';
import Tooltip from 'src/components/common/Tooltip/Tooltip';
import * as _ from 'lodash';

const ArchiveButton = (props: IArchiveButton & IGenericButtons) => {
  const { currentUser } = useContext(AuthContext);
  const { tradeService } = useContext(ServiceContext);

  function onClickHandle() {
    const archiveOrNot = props.type === ArchiveButtonTypeEnum.archive
    const errorNotification = (message?: string) => ShowNotification.Error(`Falha ao ${props.type}`, message)

    props.setLoading(true);
    tradeService
      .putArchiveTrade({ archiveOrNot, tradeId: props.trade.id })
      .then(e => e.success ? ShowNotification.Success(`Trade ${props.type}!`, `O trade foi ${props.type} com sucesso`) : errorNotification(e.message))
      .catch(err => errorNotification(err.response.status === 422 ? err.response.data : "Ocorreu um erro durante a operação. Tente novamente."))
      .finally(() => {
        props.setLoading(false);
        if (_.isFunction(props?.updateParent)) {
          props.updateParent();
        }
      });
  }

  return (
    <>
      {currentUser.permissions.canArchive && (
        <Tooltip text={`${props.type} Trade`}>
          <button className="archive btn" onClick={onClickHandle}>
            <FontAwesomeIcon icon={faArchive} />
            {props.showButtonLabel ? props.type : null}
          </button>
        </Tooltip>
      )}
    </>
  );
};

export default ArchiveButton;



// WEBPACK FOOTER //
// ./src/components/Refatoracao/Archive/ArchiveButton.tsx